module.exports = __webpack_public_path__ + "static/11-de59ea202ccbf65385fec200a120f6ad.png";